// =============================================
// SEAFOODSSHOW — MAIN APP JS
// Cart, Nav, Language toggle, Animations
// =============================================

/* ---- State ---- */
let cart = JSON.parse(localStorage.getItem('sfs_cart') || '[]');

/* ---- DOM ready ---- */
document.addEventListener('DOMContentLoaded', () => {
  initAnnouncement();
  initNav();
  initCart();
  initSearch();
  initLangToggle();
  initScrollAnimations();
  applyLang(currentLang);
  updateCartBadge();
});

/* =============================================
   ANNOUNCEMENT BAR
   ============================================= */
function initAnnouncement() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;
  if (sessionStorage.getItem('sfs_ann_dismissed')) {
    bar.classList.add('hidden');
    return;
  }
  const close = bar.querySelector('.announcement-bar__close');
  if (close) {
    close.addEventListener('click', () => {
      bar.classList.add('hidden');
      sessionStorage.setItem('sfs_ann_dismissed', '1');
    });
  }
}

/* =============================================
   NAVIGATION
   ============================================= */
function initNav() {
  const nav = document.querySelector('.nav');
  const hamburger = document.getElementById('hamburger-btn') || document.querySelector('.nav__hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-close');
  const backdrop = document.getElementById('mobile-backdrop');

  // Scroll shadow
  window.addEventListener('scroll', () => {
    if (!nav) return;
    nav.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });

  function openMobileMenu() {
    mobileMenu?.classList.add('open');
    backdrop?.classList.add('open');
    hamburger?.classList.add('open');
    hamburger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu?.classList.remove('open');
    backdrop?.classList.remove('open');
    hamburger?.classList.remove('open');
    hamburger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', () => {
    const isOpen = mobileMenu?.classList.contains('open');
    isOpen ? closeMobileMenu() : openMobileMenu();
  });

  mobileClose?.addEventListener('click', closeMobileMenu);
  backdrop?.addEventListener('click', closeMobileMenu);

  // Keyboard close
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMobileMenu();
  });
}

/* =============================================
   LANGUAGE TOGGLE
   ============================================= */
function initLangToggle() {
  document.querySelectorAll('[data-lang-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      currentLang = currentLang === 'en' ? 'ar' : 'en';
      localStorage.setItem('sfs_lang', currentLang);
      applyLang(currentLang);
      // Re-render homepage sections if available
      if (typeof renderHomepage === 'function') renderHomepage();
    });
  });
}

function applyLang(lang) {
  const html = document.documentElement;
  html.lang = lang;
  html.dir = lang === 'ar' ? 'rtl' : 'ltr';

  // Update all [data-i18n] elements
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.dataset.i18n;
    const val = t(key);
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.placeholder = val;
    } else {
      el.textContent = val;
    }
  });

  // Update lang toggle button label
  document.querySelectorAll('[data-lang-toggle]').forEach(btn => {
    btn.textContent = lang === 'en' ? 'عربي' : 'EN';
  });

  // Load Cairo font for Arabic
  if (lang === 'ar' && !document.getElementById('cairo-font')) {
    const link = document.createElement('link');
    link.id = 'cairo-font';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
}

/* =============================================
   CART
   ============================================= */
function initCart() {
  const overlay = document.querySelector('.cart-overlay');
  const drawer = document.querySelector('.cart-drawer');
  const closeBtn = document.querySelector('.cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');

  function openCart() {
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCart() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', openCart));
  if (overlay) overlay.addEventListener('click', closeCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);

  // Keyboard close
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });
}

function addToCart(product, qty = 1) {
  const quantity = parseInt(qty, 10) || 1;
  const existing = cart.find(item => item.id === product.id);
  if (existing) {
    existing.qty += quantity;
  } else {
    cart.push({ ...product, qty: quantity });
  }
  saveCart();
  updateCartBadge();
  openCartDrawer();
}

function addMultipleToCart(items) {
  if (!items || !items.length) return;
  items.forEach(({ product, qty }) => {
    const quantity = parseInt(qty, 10) || 1;
    const existing = cart.find(item => item.id === product.id);
    if (existing) {
      existing.qty += quantity;
    } else {
      cart.push({ ...product, qty: quantity });
    }
  });
  saveCart();
  updateCartBadge();
  openCartDrawer();
}

function removeFromCart(productId) {
  cart = cart.filter(item => item.id !== productId);
  saveCart();
  updateCartBadge();
  renderCart();
}

function updateQty(productId, delta) {
  const item = cart.find(i => i.id === productId);
  if (!item) return;
  item.qty = Math.max(0, item.qty + delta);
  if (item.qty === 0) removeFromCart(productId);
  else {
    saveCart();
    renderCart();
  }
  updateCartBadge();
}

function saveCart() {
  localStorage.setItem('sfs_cart', JSON.stringify(cart));
}

function updateCartBadge() {
  const totalQty = cart.reduce((sum, i) => sum + i.qty, 0);
  document.querySelectorAll('.nav__cart-badge').forEach(badge => {
    badge.textContent = totalQty;
    badge.classList.toggle('visible', totalQty > 0);
  });
}

function openCartDrawer() {
  const overlay = document.querySelector('.cart-overlay');
  const drawer = document.querySelector('.cart-drawer');
  if (!overlay || !drawer) return;
  overlay.classList.add('open');
  drawer.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}

function renderCart() {
  const body = document.querySelector('.cart-drawer__body');
  const subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
  const countEl = document.querySelector('.cart-drawer__count');
  if (!body) return;

  const totalQty = cart.reduce((sum, i) => sum + i.qty, 0);
  const subtotal = cart.reduce((sum, i) => sum + parseFloat(i.price) * i.qty, 0);

  if (countEl) countEl.textContent = '(' + totalQty + ')';
  if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);

  if (cart.length === 0) {
    body.innerHTML = `
      <div class="cart-drawer__empty">
        <div class="cart-drawer__empty-icon">🛒</div>
        <div class="cart-drawer__empty-title" data-i18n="cart_empty">${t('cart_empty')}</div>
        <div class="cart-drawer__empty-text" data-i18n="cart_empty_sub">${t('cart_empty_sub')}</div>
      </div>`;
    return;
  }

  // Quick In-Cart Recommendations (Impulse Sauces / Pairings)
  const cartItemIds = new Set(cart.map(i => i.id));
  const impulseSauces = (STORE_DATA['sauces'] || []).concat(STORE_DATA['smoked'] || [])
    .filter(p => !cartItemIds.has(p.id) && p.available !== false && p.price)
    .slice(0, 2);

  let cartUpsellHtml = '';
  if (impulseSauces.length > 0) {
    cartUpsellHtml = `
      <div class="cart-drawer-upsells">
        <div class="cart-upsells-title">✨ Frequently Added With Orders:</div>
        <div class="cart-upsells-list">
          ${impulseSauces.map(p => `
            <div class="quick-addon-card">
              <div class="quick-addon-left">
                <div class="quick-addon-img">
                  <img src="${p.image || ''}" alt="${p.title}">
                </div>
                <div class="quick-addon-info">
                  <span class="quick-addon-name">${p.title}</span>
                  <span class="quick-addon-price">${formatPrice(p.price)}</span>
                </div>
              </div>
              <button type="button" class="btn-quick-add" onclick="addToCart(${JSON.stringify(p).replace(/"/g, '&quot;')})">
                + Add
              </button>
            </div>
          `).join('')}
        </div>
      </div>`;
  }

  const itemsHtml = cart.map(item => `
    <div class="cart-item">
      <div class="cart-item__img">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </div>
      <div class="cart-item__body">
        <div class="cart-item__title">${item.title}</div>
        <div class="cart-item__price">${formatPrice(parseFloat(item.price) * item.qty)}</div>
        <div class="cart-item__qty">
          <button class="cart-item__qty-btn" onclick="updateQty(${item.id}, -1)">−</button>
          <span class="cart-item__qty-val">${item.qty}</span>
          <button class="cart-item__qty-btn" onclick="updateQty(${item.id}, 1)">+</button>
          <span class="cart-item__remove" onclick="removeFromCart(${item.id})">Remove</span>
        </div>
      </div>
    </div>
  `).join('');

  body.innerHTML = itemsHtml + cartUpsellHtml;
}

/* =============================================
   SMART RECOMMENDATION & AOV ENGINE
   ============================================= */

function getSmartPairings(product, count = 3) {
  if (!product || typeof STORE_DATA === 'undefined') return [];
  
  let currentKey = '';
  for (const [key, list] of Object.entries(STORE_DATA)) {
    if (list.some(p => p.id === product.id || p.handle === product.handle)) {
      currentKey = key;
      break;
    }
  }

  let priorityKeys = [];
  if (currentKey === 'raw_salmon' || currentKey === 'smoked') {
    priorityKeys = ['sauces', 'shrimps', 'sea_fruits', 'bundles'];
  } else if (currentKey === 'shrimps') {
    priorityKeys = ['sauces', 'smoked', 'raw_salmon', 'sea_fruits'];
  } else if (currentKey === 'sea_fruits') {
    priorityKeys = ['sauces', 'shrimps', 'raw_salmon', 'smoked'];
  } else if (currentKey === 'sauces') {
    priorityKeys = ['raw_salmon', 'shrimps', 'smoked', 'sea_fruits'];
  } else if (currentKey === 'bundles' || currentKey === 'sahel') {
    priorityKeys = ['sauces', 'smoked', 'shrimps', 'sea_fruits'];
  } else {
    priorityKeys = ['sauces', 'shrimps', 'smoked', 'raw_salmon'];
  }

  const selected = [];
  const seenIds = new Set([product.id]);

  for (const key of priorityKeys) {
    if (selected.length >= count) break;
    const items = STORE_DATA[key] || [];
    const candidate = items.find(item => !seenIds.has(item.id) && item.available !== false && item.price);
    if (candidate) {
      selected.push(candidate);
      seenIds.add(candidate.id);
    }
  }

  if (selected.length < count) {
    for (const key of Object.keys(STORE_DATA)) {
      if (selected.length >= count) break;
      const items = STORE_DATA[key] || [];
      for (const item of items) {
        if (selected.length >= count) break;
        if (!seenIds.has(item.id) && item.available !== false && item.price) {
          selected.push(item);
          seenIds.add(item.id);
        }
      }
    }
  }

  return selected;
}

/* Frequently Bought Together Bundle Renderer */
function renderFrequentlyBoughtTogether(mainProduct, containerId = 'fbt-container') {
  const container = document.getElementById(containerId);
  if (!container || !mainProduct) return;

  const rawMainPrice = mainProduct.price ?? mainProduct.variants?.[0]?.price ?? 0;
  const numMainPrice = typeof rawMainPrice === 'number' ? rawMainPrice : parseFloat(String(rawMainPrice).replace(/[^0-9.]/g, '')) || 0;

  const pairings = getSmartPairings(mainProduct, 2);
  if (!pairings || pairings.length === 0) {
    container.style.display = 'none';
    return;
  }

  const allBundleProducts = [
    { ...mainProduct, price: numMainPrice },
    ...pairings.map(p => {
      const pPrice = p.price ?? p.variants?.[0]?.price ?? 0;
      const numPPrice = typeof pPrice === 'number' ? pPrice : parseFloat(String(pPrice).replace(/[^0-9.]/g, '')) || 0;
      return { ...p, price: numPPrice };
    })
  ];
  window._activeFbtProducts = allBundleProducts;

  container.style.display = 'block';
  container.innerHTML = `
    <div class="frequently-bought" data-animate>
      <div class="fbt-header">
        <span class="fbt-label">Chef Recommended Combo</span>
        <h3 class="fbt-title">Frequently Bought Together</h3>
      </div>

      <!-- Visual Images Row with Plus Symbols -->
      <div class="fbt-visual-row">
        ${allBundleProducts.map((p, idx) => `
          ${idx > 0 ? `<div class="fbt-plus-icon">+</div>` : ''}
          <div class="fbt-thumb-card" id="fbt-thumb-${idx}">
            <img src="${p.image || ''}" alt="${p.title}">
          </div>
        `).join('')}
      </div>

      <!-- Checklist -->
      <div class="fbt-checklist">
        ${allBundleProducts.map((p, idx) => `
          <label class="fbt-check-item">
            <input type="checkbox" id="fbt-check-${idx}" data-index="${idx}" data-price="${p.price}" checked onchange="handleFbtCheckboxChange()">
            <span>
              ${idx === 0 ? `<span class="fbt-current-badge">This item:</span>` : ''}
              <span class="fbt-item-title">${p.title}</span> — 
              <span class="fbt-item-price">${formatPrice(p.price)}</span>
            </span>
          </label>
        `).join('')}
      </div>

      <!-- Price & CTA Bar -->
      <div class="fbt-bottom-bar">
        <div class="fbt-pricing">
          <span class="fbt-total-label">Total Bundle Price:</span>
          <span class="fbt-total-price" id="fbt-total-price">${formatPrice(numMainPrice)}</span>
          <span class="fbt-savings-tag">⚡ Same-day fresh delivery ready!</span>
        </div>
        <button type="button" class="btn-fbt-add" id="fbt-add-btn" onclick="addFbtBundleToCart()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <span id="fbt-btn-text">Add All 3 to Cart</span>
        </button>
      </div>
    </div>
  `;

  handleFbtCheckboxChange();
}

function handleFbtCheckboxChange() {
  const products = window._activeFbtProducts || [];
  let total = 0;
  let selectedCount = 0;

  products.forEach((p, idx) => {
    const cb = document.getElementById(`fbt-check-${idx}`);
    const thumb = document.getElementById(`fbt-thumb-${idx}`);
    const rawP = cb?.dataset?.price ?? p.price;
    const itemPrice = typeof rawP === 'number' ? rawP : parseFloat(String(rawP).replace(/[^0-9.]/g, '')) || 0;
    if (cb && cb.checked) {
      total += itemPrice;
      selectedCount++;
      if (thumb) thumb.classList.remove('unchecked');
    } else if (thumb) {
      thumb.classList.add('unchecked');
    }
  });

  const priceEl = document.getElementById('fbt-total-price');
  const btn = document.getElementById('fbt-add-btn');
  const btnText = document.getElementById('fbt-btn-text');

  if (priceEl) priceEl.textContent = formatPrice(total);
  if (btn) btn.disabled = selectedCount === 0;
  if (btnText) {
    if (selectedCount === products.length) {
      btnText.textContent = `Add All ${products.length} to Cart`;
    } else {
      btnText.textContent = `Add Selected (${selectedCount}) to Cart`;
    }
  }
}

function addFbtBundleToCart() {
  const products = window._activeFbtProducts || [];
  const toAdd = [];
  products.forEach((p, idx) => {
    const cb = document.getElementById(`fbt-check-${idx}`);
    if (cb && cb.checked) {
      toAdd.push({ product: p, qty: 1 });
    }
  });
  if (toAdd.length) {
    addMultipleToCart(toAdd);
  }
}

/* Quick Add-ons Strip (Below Main Add to Cart CTA) */
function renderQuickAddons(mainProduct, containerId = 'quick-addons-container') {
  const container = document.getElementById(containerId);
  if (!container || !mainProduct) return;

  const pairings = getSmartPairings(mainProduct, 2);
  if (!pairings || !pairings.length) {
    container.style.display = 'none';
    return;
  }

  container.style.display = 'block';
  container.innerHTML = `
    <div class="product-quick-addons">
      <div class="quick-addons-title">
        <span>🥢 Complete Your Meal (1-Click Add):</span>
      </div>
      <div class="quick-addons-list">
        ${pairings.map(p => `
          <div class="quick-addon-card">
            <div class="quick-addon-left">
              <div class="quick-addon-img">
                <img src="${p.image || ''}" alt="${p.title}">
              </div>
              <div class="quick-addon-info">
                <span class="quick-addon-name">${p.title}</span>
                <span class="quick-addon-price">${formatPrice(p.price)}</span>
              </div>
            </div>
            <button type="button" class="btn-quick-add" onclick="handleQuickAddClick(${JSON.stringify(p).replace(/"/g, '&quot;')}, this)">
              + Add
            </button>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

function handleQuickAddClick(product, btn) {
  if (btn) {
    btn.textContent = '✓ Added';
    btn.classList.add('added');
    setTimeout(() => {
      btn.textContent = '+ Add';
      btn.classList.remove('added');
    }, 1500);
  }
  addToCart(product, 1);
}

/* =============================================
   SEARCH MODAL
   ============================================= */
function initSearch() {
  const modal = document.querySelector('.search-modal');
  const triggers = document.querySelectorAll('[data-search-toggle]');
  const closeBtn = modal?.querySelector('.search-modal__close');
  const input = modal?.querySelector('.search-modal__input');

  function openSearch() {
    modal?.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input?.focus(), 100);
  }
  function closeSearch() {
    modal?.classList.remove('open');
    document.body.style.overflow = '';
    if (input) input.value = '';
  }

  triggers.forEach(btn => btn.addEventListener('click', openSearch));
  closeBtn?.addEventListener('click', closeSearch);
  modal?.addEventListener('click', e => { if (e.target === modal) closeSearch(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSearch(); });
}

/* =============================================
   PRODUCT CARD BUILDER (SF Expanse style)
   ============================================= */
function buildProductCard(product, delay = 0) {
  const savings = calcSavings(product.price, product.compare_at_price);
  const isAvailable = product.available !== false;
  const hasSale = savings && savings > 0;

  const badges = [];
  if (hasSale) badges.push(`<span class="badge badge-sale">${savings}% OFF</span>`);
  if (!isAvailable) badges.push(`<span class="badge badge-oos">Sold Out</span>`);

  const productUrl = `product.html?handle=${product.handle}`;

  return `
    <div class="product-card" data-animate data-animate-delay="${delay}">
      <div class="product-card__img-wrap" onclick="location.href='${productUrl}'">
        <img class="product-card__img" src="${product.image || ''}" alt="${product.title}" loading="lazy" onerror="this.src='data:image/svg+xml,<svg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'400\\' height=\\'400\\'><rect width=\\'400\\' height=\\'400\\' fill=\\'%23f2f2f0\\'/><text x=\\'50%\\' y=\\'50%\\' dominant-baseline=\\'middle\\' text-anchor=\\'middle\\' font-size=\\'48\\'>🐟</text></svg>'">
        ${badges.length ? `<div class="product-card__badges">${badges.join('')}</div>` : ''}
        ${isAvailable ? `
        <button type="button" class="product-card__quick-add"
          onclick="event.stopPropagation(); addToCart(${JSON.stringify(product).replace(/"/g, '&quot;')})">
          + Quick Add
        </button>` : ''}
      </div>
      <div class="product-card__body">
        <h3 class="product-card__title" onclick="location.href='${productUrl}'">${product.title}</h3>
        <div class="product-card__price">
          <span class="product-card__price-current price-color">${formatPrice(product.price)}</span>
          ${hasSale ? `<span class="product-card__price-compare">${formatPrice(product.compare_at_price)}</span>` : ''}
          ${hasSale ? `<span class="product-card__savings">Save ${savings}%</span>` : ''}
        </div>
        <button type="button" class="btn-card-add${!isAvailable ? ' out-of-stock' : ''}"
          onclick="event.stopPropagation(); ${isAvailable ? `addToCart(${JSON.stringify(product).replace(/"/g, '&quot;')})` : ''}"
          ${!isAvailable ? 'disabled' : ''}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
          <span data-i18n="${isAvailable ? 'add_to_cart' : 'out_of_stock'}">${isAvailable ? t('add_to_cart') : t('out_of_stock')}</span>
        </button>
      </div>
    </div>`;
}

/* =============================================
   SCROLL ANIMATIONS (IntersectionObserver)
   ============================================= */
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

  // Re-observe after dynamic render
  window.observeNewAnimations = () => {
    document.querySelectorAll('[data-animate]:not(.animated)').forEach(el => observer.observe(el));
  };
}
